import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Info — hints and informational banners. */
export function InfoIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <circle cx="12" cy="12" r="8.25" />
      <path d="M12 11v5.2" />
      <path d="M12 7.4h.01" />
    </PortalIcon>
  );
}
